import Button from '@/component/Button'
import CurrencyIcon from '@/component/CurrencyIcon'
import WalletContext from '@/context/WalletContext'
import { PopUpStore } from '@/store/PopupStore'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

const DiamondBalance: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { wallet } = useContext(WalletContext)

  const diamondCurrency = wallet?.diamond

  if (!diamondCurrency) {
    return null
  }

  return (
    <div className="mb-md overflow-hidden rounded-2xl bg-[#70c1fe] px-md py-sm text-white">
      <div className="flex items-center justify-between mb-sm">
        <h3 className="font-bold text-base">
          {t('currency.diamond')} {t('title.balance')}
        </h3>
        <Button
          type="link"
          className="p-0 text-sm font-normal text-white underline underline-offset-1 h-auto"
          onClick={() =>
            PopUpStore.setBillingPopup({
              visible: true,
              active: 'DIAMOND'
            })
          }
        >
          {t('btn.transactionBreakdown')}
        </Button>
      </div>

      <div className="flex flex-grow items-center gap-sm">
        <CurrencyIcon code="diamond" size="large" />
        <span className="font-custom-bold text-4xl">{wallet.diamond?.balance}</span>
      </div>
    </div>
  )
}

interface PropType {}

export default DiamondBalance
